export default __webpack_public_path__ + "static/media/clear-menu.244b6687.svg";